import React from 'react';

import clsx from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, fullWidth = true, className, id, ...props }, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div className={clsx(fullWidth && 'w-full')}>
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-semibold text-gti-navy mb-1.5 font-montserrat"
          >
            {label}
          </label>
        )}
        <input
          id={inputId}
          ref={ref}
          className={clsx(
            'block px-3 py-2.5 border-2 rounded-md shadow-sm placeholder-gray-400 font-montserrat text-base',
            'focus:outline-none focus:ring-2 focus:ring-gti-navy/20 focus:border-gti-navy',
            'transition-all duration-200 h-11',
            error
              ? 'border-red-300 text-red-900 focus:ring-red-500 focus:border-red-500'
              : 'border-gti-navy/20 hover:border-gti-navy/40',
            fullWidth && 'w-full',
            className
          )}
          {...props}
        />
        {error && <p className="mt-1 text-sm text-red-600 font-medium">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
